module.exports = __webpack_public_path__ + "static/img/two-flex4.db82b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/two-flex4.png
// module id = J5Ho
// module chunks = 0